export default "__VITE_ASSET__62cfe01d__"